"use client";

import { Button } from "@/components/ui/button";
import TicketIcon from "@heroicons/react/24/solid/TicketIcon";
import AddCompanyButton from "../all-companies/AddCompanyButton";
import { useState } from "react";
import CompaniesInfiniteScroll from "./CompaniesInfiniteScroll";
import dynamic from "next/dynamic";
import { useTranslation } from "@/hooks/translationContext";

const CompanyDiscountsModal = dynamic(
  () => import("../company-discounts/CompanyDiscountsModal"),
);

export default function PlaceDetailsCompany({
  datas,
  venueTitle,
  id,
  phone,
}: {
  datas: any;
  venueTitle: string;
  id: number;
  phone: string;
}) {
  const {t} = useTranslation();
  const [openCompanyModal, setOpenCompanyModal] = useState(false);

  const redefineMessageKey = "company-discount-renewal-message-in-venue-detail";
  const redefineMessage = t(redefineMessageKey, {
    ...datas?.usageData,
    defaultValue: "İndirim hakkı gelecek ay yenilenecek."
  });

  const getCompanyDiscountText = () => {
    if (datas.usageData?.remainingDiscount == 0) return redefineMessage;
    return t("venue-detail-remaining-discount-label", {
      remainingDiscount: datas.usageData?.remainingDiscount,
    })
  }

  return (
    <div
      id="company-discounts"
      className="mt-6 relative flex flex-col gap-4 mb-6 lg:max-w-[895px] border rounded-[32px] px-4 pt-4 pb-2"
    >
      {openCompanyModal && (
        <CompanyDiscountsModal
          id={id}
          isOpen={openCompanyModal}
          onClose={() => setOpenCompanyModal(false)}
        />
      )}

      <div className="flex gap-1 bg-stone-50 rounded-[16px] py-1.5 px-2 justify-between items-center">
        <div className="flex items-center gap-2">
          <TicketIcon className="size-6 text-primary" />
          <h2 className="text-primary font-bold text-sm">
            İndirim Verilen Şirketler
          </h2>
          <div className="py-[2px] cursor-default max-h-[24px] px-[6px] text-xs bg-primary text-white font-[500] rounded-full">
            {datas.summary?.count}
          </div>
        </div>

        <Button
          variant="assistant"
          onClick={() => setOpenCompanyModal(true)}
          className="text-[10px] flex !h-6 justify-center items-center text-sm font-bold px-2 py-1"
        >
          Tümünü Gör
        </Button>
      </div>

      <div className="flex items-center justify-center">
        <span className="text-sm text-assistant font-bold">
          {getCompanyDiscountText()}
        </span>
      </div>

      <div className="w-full flex flex-col gap-3 items-center">
        <div className="w-full">
          <CompaniesInfiniteScroll
            venueId={id}
            venueTitle={venueTitle}
            initialData={datas}
          />
        </div>

        <div className="text-xs font-medium text-assistant">
          İndirim Kartınızı görmek için şirket logosuna tıklayın!
        </div>

        <AddCompanyButton venue={venueTitle} />
      </div>
    </div>
  );
}
